import { getFromStorage } from "../utils/Helper";
import { StorageConstant } from "./Constants";

const EnglishLanguage = {
  HOME:'Home',
  VIEW: 'View',
  VIEW_ALL: 'View all',
  PRE_PRODUCT_PRICE: 'Unit Price',
  REQUIRED_LOACTION: 'Please select loaction type',
  RESIDENTIAL: 'Residential',
  LABORAL: 'Business',
  // LABORAL: 'Commercial',
  INDUSTRIAL: 'Industrial',
  // LOACTION_TYPE: 'Type Of Domicile',
  LOACTION_TYPE: 'Type Of Residence',
  AWB_NUMBER: 'AWB Number',
  WAYBILLNUMBER: 'Waybill Number',
  SHIPPINSCompany: 'Shipping Company',
  TRAKING_URL: 'Tracking Url',
  TRAKING_NUMBER: 'Tracking Number',
  SHPPING_DEATILS: "Shipping Details",
  ORDER_SHIPPING_MODAL_TITLE: "Shipping",
  ORDER_SHIPPING_COMPANY_LABEL: "Company",
  ORDER_TRACKING_NUMBER_HASH: "Tracking number#",
  ORDER_SPECIAL_INSTRUCTIONS: "Special Instructions",
  CHANGE_ADDRESS_DES: 'If you change the address then current quotation will not be valid and the request will be sent again to the admin.',
  CHANGE_ADDRESS: 'Change Address',
  VALID_PHONE_NUMBER: "Phone number must be at last 7 numbers.",
  PHONE_MAX_CHAR: "Phone number cannot exceed more than 15 numbers.",
  PHONE_NUMBER_VALID: "Entered mobile number is invalid, please try again.",
  VALID_PHONE: 'Please enter valid phone number',
  EMAIL_ADDRESS: 'Please enter valid email address.',
  EMAIL_MAX: 'Email cannot exceed more than 150 characters',
  EMAIL_MIN: 'Email must be at least 3 characters',
  PLEASE_ENTER_Email: 'Please enter your Email',
  NAME_MAX: 'Name cannot exceed more than 25 characters',
  NAME_MIN: 'Name must be at least 3 characters',
  PLEASE_ENTER_NAME: 'Please enter your name',
  STREET_LINE_OTHER: "Street line cannot contain consecutive spaces",
  STREET_LINE_CONTACT_DES_MAX: 'street line cannot exceed more than 250 characters',
  STREET_LINE_DES_MIN: 'street line must be at least 3 characters',
  STREET_LINE: 'Please enter your street line',
  SELECT_EXCEL: "Please select excel file",
  ENTER_PASSWORD: "Please enter password",
  Emojis: 'Emojis and special characters not allowed',
  DES_LINE: 'description line cannot contain consecutive spaces',
  CONTACT_DES_MAX: 'description cannot exceed more than 500 characters',
  DES_MIN: 'description must be at least 3 characters',
  ENTER_DESC: "Please enter your description",
  PASSWORD_CONFIRM_PASSWORD_MUST_MATCH: "New password and confirm password must be same",

  CONFIRM_PASSWORD_MIN_CHAR: "Confirm password must have at least 8 characters.",
  CONFIRM_PASSWORD_MAX_CHAR: "Confirm Password should not exceed 16 characters",
  NEW_PASSWORD_REQUIRED: "Please enter new password.",
  NEW_PASSWORD_MIN_CHAR: "New password must have at least 8 characters.",
  NEW_PASSWORD_MAX_CHAR: "New Password should not exceed 16 characters",

  REQUIRED: "Required",
  CONFIRM_NEW_PASSWORD_REQUIRED: "Please enter confirm password.",
  CONFIRM_NEW_PASSWORD_MIN_CHAR: "Re-enter password must have at least 8 characters.",
  CONFIRM_NEW_PASSWORD_MAX_CHAR: "Re-enter Password should not exceed 16 characters.",
  // PASSWORD_CPWD_NOT_MATCHED: "Entered password doesn't match. please try again",
  PASSWORD_CPWD_NOT_MATCHED: "New password and Confirm password does not match.",
  PASSWORD_OLD_NOT_SAME: "You have already use this password before, please set another password",


  NEW_OLD_PASSWORD_SAME: 'New password cannot be  same as the old password',
  PASSWORD_MATCH: "Password should be between 8 to 15 characters and should contain atleat one uppercase, one lowercase, one number and one special character.",
  PASSWORD_VALID: "Password must contain alphanumeric characters that includes atleast 1 upper case character and 1 special character.",
  PASSWORD_UPPER_CASE: "Password must contain alphanumeric characters that includes atleast 1 upper case character and 1 special character.",
  PASSWORD_SPECIAL_CASE: "Password must contain alphanumeric characters that includes atleast 1 uppercase, 1 lowercase and 1 special character.",
  PASSWORD_NUMBER_CASE: "Password must contain alphanumeric characters that includes atleast 1 upper case character and 1 special character.",

  PASSWORD_REQUIRED: "Please enter password.",
  CONFIRM_PASSWORD_REQUIRED: "Please enter confirm  password.",
  NO_SPACE_ALLOWED: "No space allowed.",
  OLD_PASSWORD_REQUIRED: "Please enter old password.",
  OLD_PASSWORD_MIN_CHAR: "Old password must have at least 8 characters.",
  OLD_PASSWORD_MAX_CHAR: "Old Password should not exceed 16 characters.",
  EXCEED: "cannot exceed more than",
  MAX: 'must be at least',
  PLEASE_SELECT: 'Please select your',
  PLEASE_ENTER: 'Please enter your',
  VERFIY_EMAIL: 'Please verfiy your email',
  OTHER_MAX: "Other brand name cannot exceed 50 characters",
  OTHER_MIN: "Other brand name minimum 1 words",
  OTHER_BRAND_REQUIRED: "Other brand name is required",
  MODAL_MAX: "Model number cannot exceed 50 characters",
  SER_MAX: "Serial number cannot exceed 50 characters",
  DES_MAX: 'Description must be at most 250 characters',
  QUNTITY_NUMBER: "Please enter only number",
  QUNTITY_MAX: 'Quantity cannot exceed 1000000 ',
  QUNTITY_MIN: 'Quantity must be at least 1',
  QUNITYTY_REQUIRED: "Quantity is required",
  PART_NUMBER_MAX: 'Part Number cannot exceed 50 characters',
  PART_NUMBER_MIN: 'Part Number must be at least 1 character',
  PART_NUMBER_REQUIRED: 'Part Number is required',
  BRAND_NAME_REQUIRD: 'Brand Name is required',
  BRAND_NAME_ALREDY: 'Brand name already exists.',
  PLEASE_SELECT_SHIPPING_TYPE: 'Please select shipping method',
  PLEASE_SELECR_DELIVER_ADDRESS: 'Please select delivery address',
  PLEASE_SELECT_TYPE: 'Please select a type',
  CUSTOMER_PURCHASED: "Customers have also purchased",
  PRODUCTLISTING: "Product Listing",
  CONTACTUS: "Contact Us",
  FOOTER_TRENDING_PRODUCTS: "Trending Products",
  FOOTER_CONTACT_SUPPORT: "Contact Support",
  CONTACT_SUPPORT_LEAD: "We're here to help. Send us a message and we'll get back to you.",
  CONTACT_SUPPORT_MSG_PLACEHOLDER: "Tell us what's going on. The more the better.",
  CONTACT_SUPPORT_CHAR_COUNT: "Character count",
  CONTACT_SUPPORT_THANKS: "Thanks! Your message was sent.",
  CONTACT_SUPPORT_CLOSE_HINT: "You can close this tab or return to the site.",
  CONTACT_SUPPORT_BACK_HOME: "Back to home",
  CONTACT_SUPPORT_CLOSE_ARIA: "Close",
  PRODUCTSUGGESTIOND: "Product Suggestions",
  REQUESTQUOTES: "Start a Quote",
  LETS_GO: "Let's Go",
  ABOUTUS: 'About Us',
  TESTIMONIAL: "Testimonials",
  CLIENTREVIEW: 'What happy clients say about us?',
  PRIACYPOLICY: "Privacy Policy",
  TERMS: 'Terms & Conditions',
  COPYRIGHT: "© 2025-2026 Quote n Buy. All rights reserved.",
  FAQS: "FAQ'S",
  LOGIN: "Login",
  BACK_TO_LOGIN: "Back to",
  LOGOUT: "Logout",
  VIEWPROFILE: "View Profile",
  MY_DETAILS: "My Details",
  MYORDER: "My Orders",
  MYADDRESS: "Address Book",
  ADDRESS_EMPTY_STATE_MESSAGE:
    "Looks like you haven't added an address yet. Add one now to start quoting.",
  MYOUESTION: 'My Quotes',
  DRAFTS: 'Drafts',
  SETTING: 'Settings',
  CHANGEPASSWORD: "Change Password",
  CHANGE_PASSWORD_SUBTITLE: "Set a new password for your account",
  OLD_PASSOWRD: 'Old Password',
  NOTIFIACTION: 'Notification Setting',
  DELETEACCOUNT: "Delete Account",
  QUOTATIONFORM: 'Manual Entry',
  QUOTATIONFORM_DESC: 'Enter product details one by one',
  REQUESTVIA: 'Request via',
  BULKREQUEST: "Bulk Request via",
  EXCEL: 'Bulk Upload',
  EXCEL_DESC: 'Upload an Excel file using our template',
  COUNTINUE: "Continue",
  DELIVERYADDRESS: 'Select Delivery Address',
  SHIPPINGMETHOD: 'Select Shipping Method',
  NEWADDRES: "Add New Address",
  UPDATEADDRES: "UPDATE ADDRESS",
  NEXT: "Next",
  SAVE_FOR_LATER: "Save for Later",
  SAVE_FOR_LATER_MIN_ENTRY:
    "Please fill at least one item field on the Data Entry tab before saving to drafts.",
  SAVE_FOR_LATER_HINT_TITLE: "Almost there",
  GOT_IT: "Got it",
  REVIEW: "Review",
  REQUEST_A_QUOTE: "Request a Quote",
  BULK_ENTRY_NAV: "Bulk Entry",
  BULK_ENTRY_TAGLINE:
    "For orders with multiple items, bulk entry makes things faster and easier.",
  BULK_DOWNLOAD_CARD_TITLE: "Download Excel Template",
  BULK_REDOWNLOAD_CARD_TITLE: "Redownload Excel Template",
  BULK_DOWNLOAD_CARD_SUB: "Get the template to fill in your items.",
  BULK_UPLOAD_CARD_TITLE: "Upload Excel File",
  BULK_UPLOAD_CARD_SUB: "Click to upload your filled template.",
  BULK_UPLOAD_UPLOADED_CARD_TITLE: "Uploaded Excel File",
  /** Shown when a file is selected; click the card to replace the file. */
  BULK_UPLOAD_REPLACE_FILE: "Replace Excel file",
  BULK_DELETE_UPLOADED_FILE: "Delete Uploaded File",
  BULK_REMOVE_UPLOAD_TITLE: "Remove Upload",
  BULK_REMOVE_UPLOAD_LINE1: "Want to replace this file?",
  BULK_REMOVE_UPLOAD_LINE2: "You can upload a new one once it's removed.",
  BULK_REMOVE_UPLOAD_KEEP: "Keep",
  BULK_REMOVE_UPLOAD_REMOVE: "Remove",
  BULK_PREVIEW_FILE_SHORT: "Preview File",
  POPUP_BLOCKED: "Allow pop-ups for this site to open the file in a new tab.",
  BULK_PREVIEW_UPLOADED_FILE: "Preview Uploaded File",
  BULK_EXCEL_FILE_PREFIX: "Excel File",
  BULK_EXCEL_ENTER_DATA: "Incorrect information provided in the Excel sheet.",
  BULK_EXCEL_INVALID_HEADER: "Please enter valid Excel sheet format.",
  BULK_SHIPPING_PREFS_SAVED: "Preferences saved.",
  BULK_SET_PRIMARY_ADDRESS: "Set as Primary Address",
  WIZARD_STEP_DATA_ENTRY: "Data Entry",
  WIZARD_STEP_SHIPPING: "Shipping",
  WIZARD_STEP_REVIEW: "Review",
  GRID_VIEW: "Grid View",
  LIST_VIEW: "List View",
  TABLE_VIEW: "Table View",
  MANUAL_QUOTE_DELIVERY_SECTION: "Delivery Address",
  MANUAL_QUOTE_RESIDENCE: "Type of Residence",
  MANUAL_QUOTE_SELECT_RESIDENCE: "Select Residence Type",
  MANUAL_QUOTE_BILLING_SAME: "Billing Address is the same as shipping",
  MANUAL_QUOTE_SHIPPING_METHOD_SECTION: "Shipping Method",
  MANUAL_QUOTE_PLACEHOLDER_ADDRESS_LINE: "Enter address",
  MANUAL_QUOTE_PLACEHOLDER_INSTRUCTIONS: "Enter instructions",
  MANUAL_QUOTE_SHIPPING_DETAILS: "Shipping Details",
  MANUAL_QUOTE_INSTRUCTIONS: "Instructions for delivery (optional)",
  ADDRESS_LINE_1: "Address Line 1",
  ADDRESS_LINE_2: "Address Line 2",
  PART_NUMBER_HASH: "Part #",
  QTY_SHORT: "Qty",
  SKU_LABEL: "SKU",
  UPLOAD_IMAGES: "Upload Files",
  MANUAL_QUOTE_CHIP_IMAGE_1: "Image 1",
  MANUAL_QUOTE_CHIP_IMAGE_2: "Image 2",
  MANUAL_QUOTE_CHIP_VIDEO: "Video",
  /** Manual quote Review step only — full labels (not “Part #” / “Serial #”). */
  MANUAL_QUOTE_REVIEW_PART_NUMBER: "Part Number",
  MANUAL_QUOTE_REVIEW_SERIAL_NUMBER: "Serial Number",
  DISPLAY_VALUE_NA: "N/A",
  ADD_ITEM_PLUS: "Add Item",
  DRAFT_SAVED: "Your quote progress was saved. You can continue later from Request a quote.",
  DRAFT_SAVED_LIST: "Saved to your drafts. Open Drafts in the menu anytime to continue, edit, or delete.",
  MANUAL_DRAFTS_PAGE_HEADING: "Saved drafts",
  MANUAL_DRAFTS_PAGE_SUB: "Manual quote requests you saved with Save for later.",
  MANUAL_DRAFTS_DEVICE_SECTION: "On this device",
  MANUAL_DRAFTS_ACCOUNT_SECTION: "Saved on your account",
  MANUAL_DRAFTS_LOADING_ACCOUNT: "Loading account drafts…",
  MANUAL_DRAFTS_EMPTY: "No saved drafts yet. Start a manual quote and use Save for later to keep progress here.",
  MANUAL_DRAFTS_COL_PREVIEW: "Draft Preview",
  MANUAL_DRAFTS_COL_SAVED: "Date",
  MANUAL_DRAFTS_META_DATE: "Date",
  MANUAL_DRAFTS_COL_ITEMS: "Items",
  MANUAL_DRAFTS_COL_STEP: "Step",
  MANUAL_DRAFTS_STEP_1: "Items",
  MANUAL_DRAFTS_STEP_2: "Shipping",
  MANUAL_DRAFTS_STEP_3: "Review",
  MANUAL_DRAFTS_UNTITLED: "Quote draft",
  MANUAL_DRAFTS_DELETE_CONFIRM_TITLE: "Delete this draft?",
  MANUAL_DRAFTS_DELETE_CONFIRM_TEXT: "You will not be able to recover it.",
  MANUAL_DRAFT_DELETED: "Draft deleted.",
  MANUAL_DRAFTS_NEW_QUOTE: "Start new quote",
  BUSINESS_PROFILE_GATE_TITLE: "Complete your business profile",
  BUSINESS_PROFILE_GATE_TEXT:
    "Business accounts must complete their company profile before requesting a quote. Update your profile to continue.",
  BUSINESS_PROFILE_REQUIRED_TOAST: "Please complete your business profile before requesting a quote.",
  SAVE_FOR_LATER_CONFIRM_TITLE: "Save to drafts?",
  SAVE_FOR_LATER_CONFIRM_TEXT: "Your progress will be saved. You will be taken to the Drafts screen to review or continue later.",
  SAVE_FOR_LATER_CONFIRM_HTML:
    "Your request will be saved, and you'll be redirected to your drafts.<br/><br/>Would you like to continue?",
  QUOTE_REQUEST_SENT_TITLE: "Request sent",
  QUOTE_REQUEST_SENT_HTML: "Your quote request was sent to our team. Returning to Home in a few seconds…",
  QUOTE_SUCCESS_THANK_YOU: "Thank you for quoting with us!",
  QUOTE_SUCCESS_RECEIVED: "Your request has been received",
  QUOTE_SUCCESS_REVIEWING: "We’re reviewing the details and will notify you as soon as your quote is ready",
  MANUAL_QUOTE_CLOSE_PREVIEW: "Close",
  MANUAL_QUOTE_COMPLETE_ITEMS: "Please complete all required item fields before continuing.",
  MANUAL_QUOTE_COMPLETE_SHIPPING_TAB: "Please select a delivery address and shipping method before Review.",
  MANUAL_QUOTE_FIRST_ADDRESS_INTRO:
    "Complete the form below to save your first delivery address. After it is saved, you can manage addresses here and add more anytime.",
  BRANDNAME: "Brand",
  SELECTBRAND: 'Select brand',
  PARTNAME: 'Part N°',
  PARTNAMEFULL: 'Part Number',
  ENTER: 'Enter',
  QUANTITY: 'Quantity',
  EDITQUANTITY: 'Confirm Change',
  Description: 'Description',
  DESCIPTIONDETAILS: 'Write a detailed description',
  ENTERDESCIPTION: 'Enter description',
  SERIALNUMBER: 'Serial #',
  MODELNUMBER: 'Model ',
  UPLOADMEDIA: 'Photo or Video',
  ONEBYONE: 'One photo and one video',
  TWOBYTWO: 'Two photos',
  Photo: 'Photo',
  Video: 'Video',
  REMOVE: 'Remove',
  ADDMORE: 'Add New Item',
  SUBMIT: "Submit",
  EXCLSUBMIT: "Request Quote",
  REQUESTQUOTE: 'Request Quote',
  Download: 'Download',
  TEMPLATE: 'Excel Template',
  UploadExcel: 'Upload Excel',
  MYQUOTATIONS: 'My Quotations',
  PROFILE: 'Profile',
  QUOTATIONSLIST: 'Quotes',
  Filter: 'Filter',
  Reset: 'Reset',
  ALL: 'All',
  PENDING: 'Pending',
  Progress: 'In Process',
  APPROVED: 'Approved',
  REJECT: 'Rejected',
  SNO: 'S. No',
  QUOTATIONID: 'Quote ID',
  DATE: 'Date',
  STATUS: 'Status',
  SHIPPING: 'Shipping',
  PRICE: 'Price',
  OTHER: 'Other',
  CHARGES: 'Charges',
  TAX: 'Tax',
  AMOUNT: "Amount",
  NET: "Net",
  TOTAL: 'Total',
  ACTION: "Action",
  DELADDRESS: 'Delivery address',
  SHIPINNG: 'Shipping method',
  QDATE: 'Quotation Date',
  ORDERLIST: 'Order List',
  INTRANSIT: 'In Transit',
  DELIVERD: 'Delivered',
  CANVELLED: 'Cancelled',
  ORDERID: 'Order ID',
  PAYMENTSTATUS: 'Payment',
  DELIVERYSTATUS: 'Status',
  ORRDERDELIVERYADDRESS: 'Delivery Address',
  PROVIDEDQUOTATION: 'Quotation details',
  TOTALPRODUCTAMOUNT: 'Total Product Price',
  TOTALSHIIPNGAMOUNT: 'Shipping Price',
  TOTALTAX: 'Total Tax',
  GRANDTOTAL: 'Grand Total',
  CONVERTINPISO: 'Convert price in euro',
  NOTIFACTION: "Notifications",
  NOTIF_TODAY: "Today",
  NOTIF_THIS_WEEK: "This Week",
  NOTIF_EARLIER: "Earlier",
  NOTIF_SEE_ALL: "See All",
  CHAT: "Chat",
  ADDMOREPRODUCT: "Add Another Item",
  DATANOTFOUND: 'Data Not Found',
  NO_QUOTE_DATA: 'No Quote Data',
  NO_ORDER_DATA: 'No Order Data',
  NO_REQUEST_FOUND: 'No request found.',
  MORE: "More",
  PLEASE_ENTER_QUNTITY: "Please enter any product quantity",
  MY_PROFILE: "My Profile",
  EDIT_PHOTO: "Edit Photo",
  NAME: "Name",
  EMAIL_ID: "Email ID ",
  PHONE_NUMBER: "Phone Number",
  UPDATE_PROFILE: "Update Profile",
  ENTER_FULL_NAME: "Enter Full Name",
  ENTER_EMAIL_ID: "Enter Email ID",
  SELETE_ADDRESS: "Select Address",
  STREE_LINE: "Street Line",
  ENTER_STREE_LINE: "Enter street line",
  APRATMENT: "Apartment",
  ENTER_APARTMENT: "Enter apartment",
  STATE: "State",
  ENTER_STATE: "Enter state",
  CITY: "City",
  ENTER_CITY: "Enter city",
  ZIP_CODE: "Zip Code",
  ENTER_ZIP_CODE: "Enter zip code",
  Contact_Us: "Contact Us",
  MESSAGE: "Message",
  SEND: "Send",
  SHIPPINGTYPE: "Shipping Type",
  PERPIUCESPRICE: "Per Piece Price",
  SHIPPINGPRICE: 'Shipping Price',
  TOTAL_SHPPINGH: 'Shipping Price',
  TOTAL_PRODUCT_PRICE: "Total Product Price",
  Reject: 'Reject',
  Approve: 'Approve',
  PRODUCT_HISTORY: 'Product History',
  PRODUCT_REVISON_HISTORY: "Product Revision History",
  LATEST_REVISION: 'Latest Revision',
  REVISION: 'Revision',
  ORIGNAL_REQUEST: 'Original Request',
  SHIPPING_DETAILS: "Shipping details",
  FROM: 'From',
  TO: "To",
  MESSAGEDATA: 'Search by quote Id',
  DATETYPE: "MM/DD/YYYY",
  VIEW_HISTORY: 'View History',
  PAID: 'Paid',
  PRICE_BRACKDOWN: 'Price Breakdown',
  ARE_YOU_SURE: 'Are you sure',
  YOU_WANT_TO_LOGUT: 'Are you sure you want to logout ?',
  YOU_WANT_TO_DELETE: 'Are you sure you want to delete your account ?',
  YOU_WANT_TO_DELETE_NOTIFICATION: 'Do you want to delete this notification?',
  YOU_WANT_TO_DELETE_ALL_NOTIFICATION: 'Do you want to delete all notifications?',
  YOU_WANT_TO_DELETE_Address: 'Are you sure you want to delete your address ?',


  NO: 'No',
  YES: 'Yes',
  DELETE_ACCOUNT: 'Delete Account',
  DELETE_ALL: 'Delete All',
  PASSWORD: 'Password',
  CHECKOUT: 'Checkout',
  MOBILE: 'Mobile',
  ADDRESS: 'Address',
  EDIT: 'Edit',
  TOTAL_TAX_AMOUNT: 'Total Tax Amount',
  OTHER_CARGERS: 'Other Charges',
  NET_ORDER_AMOUNT: 'Net Order Amount',
  PAYMENT_MATHOD: 'Payment Method',
  ONLINE: 'Online',
  OFFLIE: 'Bank wire Transfer',
  PLACE_ORDER: 'Proceed with Payment',
  SELETE_PAYMENT_ERROR: 'Please select payment Method',
  Successful: 'Successful',
  ORDER_LINE_ONE: 'Your order has been successfully placed',
  ORDER_SUCCESS_TITLE: 'Your order has been successfully placed!',
  ORDER_SUCCESS_DESC:
    "Thank you for your purchase. Your order is now being processed, and you'll receive a confirmation email with all the details shortly.",
  ORDER_SUCCESS_WIRE_DESC:
    "An email has been sent with the information to make the payment via wire transfer. Once we receive the funds we will proceed with your order.",
  ORDER_LINE_SEC: 'Your order is in process, this is not an invoice: An email has been sent with the information to make the payment via wire transfer. Once we receive the funds we will proceed with your order .',
  GO_TO_HOME: 'Go to Home',
  ORDER_CANCEL: 'Order Cancel',
  ORDER_CANCEL_MESSAGE: 'The request will be sent to the admin, if admin approves then only the cancellation will happen.',
  CANCEL: 'Cancel',
  ORDER_CANCEL_TITAL: 'Order Cancel Reason',
  REASON: 'Reason',
  Edit_Quantity: 'Edit Quantity',
  REMOVE_PRODUCT: 'Remove',
  EDIT_Q_MESSAGE: 'If you edit the quantity, a request will be sent to the admin for approval. The prices and quantity will only be updated if the admin accepts the change. If the request is rejected, the quantity and price will remain unchanged. Do you still want to proceed with editing the quantity?',
  DELETE_TITEL: 'Delete Product',
  PRODUCT_DELETE_MESSAGE: 'If you remove the products, a request will be sent to the admin for approval. The product will only be removed if the admin approves the request. If the request is rejected, the product will remain unchanged. Do you still want to proceed with removing  product',
  OTHER_BRAND_NAME: 'Other Brand Name',
  BRAND_NAME: 'Brand Name',
  REJECT_QUTO: "you want to reject this quotation ?",
  ORDER_FILLTER_INPUT: "Search by order Id ..",
  ORDER_SEARCH_QUOTE_ID: "Search by the Order ID",
  ORDER_PAYMENT_WT_PENDING: "WT Pending",
  ORDER_PAYMENT_WT_REFUND_PENDING: "WT Refund Pending",
  ORDER_PAYMENT_DECLINED: "Declined",
  CONTINUE_TO_PAYMENT: "Continue to Payment",
  ORDER_COL_ORDER_STATUS: "Order Status",
  ORDER_COL_PMT_STATUS: "PMT Status",
  ORDER_COL_MSG: "Msg",
  ORDER_DETAILS_HEAD: "Order Details",
  ORDER_DETAIL_TABLE_PART_HASH: "Part #",
  ORDER_DETAIL_TABLE_SERIAL_HASH: "Serial #",
  NEW_PASSWORD: 'New Password',
  CONFIRMA_PASSWORD: 'Confirm New Password',
  INSTRUCTIONS: 'Instructions for delivery (Optional)',
  ENTER_INSTRUCTIONS: "Enter instructions for delivery",
  PHOTOS_VIDEO: 'Photo or Video',
  UPLOAD: 'Upload Files',
  DOWNLOAD_PDF: 'Download PDF',
  OTHER_BRAND: 'Other Brand',
  WRITE: 'Write',
  EDIT_QUANTITY: 'Edit Quantity',
  SEND_UPDATE_REQUEST: 'Send Updated Quantity',
  EXCHANGE: 'Exchange',
  HISTORY: 'History',
  ENTER_TIME_QUNTITY: 'Please enter quantity',
  ENTER_TIME_QUNTITY_NUMBER: 'Please enter only number',
  DOWNLADAPP: 'Download App',
  ORDER_QTY: 'Qty',
  DAYS: 'DAYS',
  BRAND: 'Brand',
  Item_Name: 'Item Name',
  UNIT: 'Unit',
  EXTED_PRICE: 'Extended Price',
  Charges_reason: 'Charges reason',
  SPANISH: 'Español',
  ENGLISH: 'English',
  SPA: "ESP",
  DESC_NAME_REQUIRD: 'Description is required',
  MAX_VIDEO_LIMIT_ERROR: 'You can only upload one video at a time.',
  IMAGE_VIDEO_SIZE_ERROR: 'File size exceeds the maximum limit of 25 MB.',
  IMAAGE_VIDEO: 'You can upload a maximum of two files: either one photo and one video or two photos.',
  IMAGE1: "Image 1",
  IMAGE2: "Image 2",
  VALIDIMAGE: "Please upload valid image & video",
  Item: 'Item',
  LOGIN_EMAIL_ADDRESS: "Email Address",
  LOGIN_EMAIL_ADDRESS_TEXT: "Enter email address",
  REMEBER_ME: 'Remember me',
  FORGOT_PASSWORD: "Forgot Password",
  LOGIN_MESSAGE: 'Don’t have an account?',
  SINGUP: 'Sign Up',
  SEND_OTP: 'Send OTP',
  OTP_VERIFICATION: 'OTP Verification',
  ENTER_OTP_DIGIT: 'Enter the 4 digit OTP sent to',
  DONT_RECIVE_CODE: `Didn't receive Code`,
  RESEND_IN: 'Resend in',
  RESEND_OTP: 'Resend OTP',
  VERIFY: 'Verify',
  RESET_PASSWORD: 'Reset password',
  Confirm_Password: 'Confirm Password',
  ENTER_YOUR_DETAILS: 'Enter your details to create your account',
  HAVE_ACCOUNT: 'Already have a account',
  ACCPET: "Accept",
  TERMS_SINGUP: 'Terms',
  Condition: 'Condition',
  PRIVACY_POLICY: 'Privacy Policies',
  GUEST_USER:'Continue as a',
  GUEST:'Guest',
  SINGUP_WITH:'Or Sign Up With',
  LOGIN_WITH:'Or Login With',
  ENTER_YOUR_LOGIN_DETAILS: 'Enter your details to login',
  NEW_REQUEST_QUOTES: "NEW QUOTE REQUEST",
  SELECT_METHOD:'Please select the entry method and continue',
  IAGREEWITH: "I agree with",
  ORDERQUOTATIONID: 'Quote ID',
  BACK:"Back",
  IMPORT:"Import",
  SEEPREVIEW:'See preview',
  NEW_QTY:'New Quantity',
  BY:"By",
  UPDATE:'Update',
  ARE_YOU_SURE_UPDATE:'Are you sure you want to continue without making any other changes ?',
  TRACKING:'Tracking',
  NOTIFACTION_TITAL:'Welcome to Quote & Buy!',
  NOTIFACTION_FIRST_DESC:'We are happy to see you have created an account with us. Here you can request a quote for anything. We will review your request and provide you with a quote as soon as possible.Here are your credentials for your account and remember to keep them at hand.',
  USERNAME:'Username',
  NOTIFACTION_THIRD:'You may continue to request a quote via Manual Entry or Bulk Upload when you are ready.',
  BULK_PERA:"Please download the Excel template, fill in the necessary details, upload it, and submit it to receive a quotation for bulk products.",
  CONFIRMA : 'Confirm',
  MESSAGE_FOR_PRODUCT:'Could you please first confirm if you have made any changes?',
  REFUND:'Refunded',
  BULK_REQUEST_TEXT:'Bulk Request via Excel',
  INCORRECT_TEXT:'The quotation requests for following products are not sent to the admin . You can request quotation for these products by going to the My quotations.',
  INCORRECT_DATA:'Incorrect Data',
  NO_SPACES_ALLOWED: 'Spaces are not allowed or cannot be empty',
  NEW_PENDING :'Quoting',
  NEW_Progress:'Quoted',
  CC:'CC',
  WT:'WT',
  CAETGORY_LIST:'Category Listing',
  CATEGORY_SELECT_ERROR:'Please select at least one category to continue.',
  CATEGORY_SELECT_MESSAGE:'Please select the category that interest you most (one or more)',
  SELECT_CATEGORY_TITLE: 'Select a Category',
  SELECT_CATEGORY_SUBLINE_1: 'Choose one or more categories that interest you',
  SELECT_CATEGORY_SUBLINE_2: 'You can select categories at a later time under settings',
  SKIP: 'SKIP',
  PRIZEMESSAGE:'Following price in USD',
  CATEGORY_SELECTION: "Manage Category",
  SAVE:'Save',
  SURVEY_MESSAGE:"Do you want to participate in a survey?",
  SURVEY:'Survey',
  SURVEY_TITLE:"We're here to help. Send us a message and we'll get back to you.",
  overall_experience:'Please answer all questions before submitting the survey.',
  GIVE_SURVEY: "Participate in a survey",
  QUESTIONONE:'Q1. How would you rate your shopping experience?',
  QUESTIONTWO:'Q2. The product received corresponds to what you were looking for?',
  QUESTIONTHREE:'Q3. How would experience in the payment process?',
  QUESTIONFOUR:'Q4. We appreciate you leaving us review of your overall purchase experience.?',
  SURVEY_REVIEW_PLACEHOLDER: 'Tell us your experience.',
  SURVEY_SEND: 'Send',
  Payment_Cancelled: 'Payment Cancelled',
  Payment_Cancelled1:'You cancelled the payment process.',
  Payment_Cancelled2:'No amount has been deducted from your account.',
  Payment_Failed: 'Payment Declined',
  Payment_Failed1: 'Your card payment could not be processed.',
  Payment_Failed2: 'The order was saved with a declined payment status. You can retry from My Orders.',

  OR_CONNECTOR: 'Or',
  AUTH_LANGUAGE_ARIA: 'Language',
  ACCOUNT_TYPE: 'Account type',
  ACCOUNT_TYPE_INDIVIDUAL: 'Individual',
  ACCOUNT_TYPE_BUSINESS: 'Business',
  COMPANY_NAME_LABEL: 'Company name',
  COMPANY_NAME_PLACEHOLDER: 'Company name',
  BUSINESS_FIELD_TYPE: 'Business Field Type',
  BUSINESS_FIELD_TYPE_PLACEHOLDER: 'Business field type',
  CONTACT_NAME: 'Contact Name',
  CONTACT_NAME_PLACEHOLDER: 'Contact name',
  COMPANY_TAX_ID_VAT_NUMBER: 'Company Tax ID / VAT Number',
  COMPANY_TAX_ID_VAT_NUMBER_PLACEHOLDER: 'Company tax id / VAT number',
  COMPANY_ADDRESS_LABEL: 'Company Address',
  COMPANY_ADDRESS_PLACEHOLDER: 'Company address',
  ADDITIONAL_INFO_LABEL: 'Additional Info',
  OPTIONAL_TEXT: 'Optional',
  FIRST_NAME: 'First Name',
  LAST_NAME: 'Last Name',
  COMPANY_EMAIL: 'Company email',
  SIGNUP_SUBTITLE_INDIVIDUAL: 'Enter details to create individual account.',
  SIGNUP_SUBTITLE_BUSINESS: 'Enter details to create business account.',
  OPTIONAL_MARK: '(Optional)',
  OPTIONAL_MARK_FIELD: 'Optional',
  AUTH_PROMO_TITLE: 'At Quote N Buy',
  AUTH_PROMO_TITLE_2: 'It is Very Simple!',
  AUTH_PROMO_TITLE_3: 'Regardless of Weight or Size',
  AUTH_PROMO_TEXT:
    'We specialize in finding and quoting what you need, delivering directly to your door.',
  WESPECIALIZETEXT:
    'We specialize in finding and quoting what you need, delivering directly to your door.',
  SIMPLYTEXT:
    'Simply tell us what type of part it is, for what brand, how many you need and if you have a photo, the better! We will do our best to quote what you are looking for.',
  PERHAPSTEXT:
    'Perhaps you need equipment or spare parts for your industrial, mining, agricultural machine or simply for a hobby or project you are working on.',
  OTP_ENTER_ERROR: 'Please enter OTP.',
  FORGOT_EMAIL_REQUIRED: 'Please enter email',
  FORGOT_EMAIL_INVALID: 'Please enter a valid email',
  LANDING_NAV_WHAT: 'What We Do',
  LANDING_NAV_ABOUT: 'About Us',
  LANDING_NAV_TRUST: 'Our Trust',
  LANDING_ARIA_HOME: 'Quote N Buy home',
  LANDING_ARIA_MENU: 'Menu',
  LANDING_NAV_PRIMARY: 'Primary navigation',
  LANDING_HERO_TITLE_1: 'Find What You Need',
  LANDING_HERO_TITLE_2: 'Anywhere at Anytime',
  LANDING_HERO_SUB:
    'Quote N Buy connects you with trusted global suppliers to help you source products quickly, securely, and with confidence.',
  LANDING_HERO_ALT: 'Quote N Buy mobile app',
  LANDING_HOW_BTN: 'How It Works',
  LANDING_HOW_TITLE: 'How It Works?',
  LANDING_STEP1_TITLE: 'Request',
  LANDING_STEP1_DESC: "Submit Your Request. Tell us what you're looking for.",
  LANDING_STEP2_TITLE: 'Quote',
  LANDING_STEP2_DESC: 'Receive Your Quote. We connect with suppliers and send you competitive pricing.',
  LANDING_STEP3_TITLE: 'Approve',
  LANDING_STEP3_DESC: 'Secure Delivery. Approve your order and we handle the logistics.',
  LANDING_ABOUT_LABEL: 'About Us',
  LANDING_ABOUT_HEADING: 'Built to Make Global Buying Simple',
  LANDING_ABOUT_P1:
    "At Quote N Buy, we're here to help you find exactly what you need, no matter where you are in the world.",
  LANDING_ABOUT_P2:
    "We know sourcing products internationally can feel complicated. That's why we make it simple, offering fast quotes, fair pricing, and secure delivery straight to your home or business.",
  LANDING_ABOUT_P3:
    'Through our trusted global network of suppliers, we help you access spare parts, equipment, electronics, clothing, and even those hard-to-find items that are not available locally.',
  LANDING_ABOUT_P4:
    'Our goal is to make every purchase easy, transparent, and reliable, so you can shop with confidence and peace of mind.',
  LANDING_TRUST_LABEL: 'Our Trust',
  LANDING_TRUST_CARD1_TITLE: 'Direct Brand Sourcing',
  LANDING_TRUST_CARD1_DESC:
    'We obtain products directly from trusted brands to guarantee authenticity, quality, and peace of mind.',
  LANDING_TRUST_CARD2_TITLE: 'Transparent Process',
  LANDING_TRUST_CARD2_DESC: 'Clear pricing, detailed quotes, and consistent updates, no hidden surprises.',
  LANDING_TRUST_CARD3_TITLE: 'Secure Transactions',
  LANDING_TRUST_CARD3_DESC: 'Your payments and information are protected every step of the way.',
  LANDING_TRUST_CARD4_TITLE: 'Reliable Delivery',
  LANDING_TRUST_CARD4_DESC: 'We coordinate safe and efficient shipping to your destination.',
  LANDING_REVIEWS_LABEL: 'Customer Reviews',
  LANDING_SEE_ALL: 'See All',
  LANDING_VIEW_ALL: 'View All',
  LANDING_READ_MORE: 'Read more',
  LANDING_READ_LESS: 'Read less',
  LANDING_ROLE_CUSTOMER: 'Customer',
  LANDING_REVIEW_BODY:
    "I needed specialized automotive parts that weren't available locally, and Quote N Buy handled everything for me. The quote came back quickly, pricing was transparent, and they kept me updated throughout the entire process.",
  LANDING_DAYS_AGO: '{n} days ago',
  LANDING_STARS_ARIA: '{n} out of 5 stars',
  LANDING_FOOTER_COMPANY: 'Company',
  LANDING_FOOTER_REVIEWS: 'Reviews',
  LANDING_FOOTER_FOLLOW: 'Follow Us',
  LANDING_FOOTER_GET_APP: 'Get the App',
  LANDING_FOOTER_GOOGLE_PLAY: 'Google Play',
  LANDING_FOOTER_APP_STORE: 'App Store',
  LANDING_MODAL_TITLE: 'Trusted By Customers Worldwide',
  LANDING_MODAL_OVERALL_RATING: 'Overall Rating',
  LANDING_MODAL_REVIEW_COUNT: '28 reviews',
  LANDING_FILTER_BY: 'Filter By:',
  LANDING_FILTER_ARIA: 'Filter reviews by star rating',
  LANDING_STARS_ALL: 'All stars',
  LANDING_STARS_5: '5 stars',
  LANDING_STARS_4: '4 stars',
  LANDING_STARS_3: '3 stars',
  LANDING_STARS_2: '2 stars',
  LANDING_STARS_1: '1 star',
  REVIEWS_FILTER_NO_MATCH: 'No review match this filter',
  COMPLETE_PROFILE_NOTIF_TITLE: 'Complete your Profile',
  COMPLETE_PROFILE_NOTIF_BODY:
    'Just one more step, complete your profile to get started.',
  ARIA_CLOSE: 'Close',
  DASH_HERO_0_TITLE: 'WELCOME TO QUOTE N BUY',
  DASH_HERO_0_DESC:
    'Quote N Buy connects you with trusted global suppliers to help you source products quickly, securely, and with confidence.',
  DASH_HERO_1_TITLE: 'SOURCE WITH CONFIDENCE',
  DASH_HERO_1_DESC:
    'Request quotes, compare offers, and approve orders — all in one place with transparent pricing and reliable delivery.',
  DASH_HERO_2_TITLE: 'GLOBAL REACH, LOCAL SERVICE',
  DASH_HERO_2_DESC:
    'We help you find the right parts and products from verified suppliers worldwide, tailored to your timeline and budget.',
  DASH_HERO_3_TITLE: 'YOUR PROCUREMENT PARTNER',
  DASH_HERO_3_DESC:
    'From specialized components to everyday supplies, Quote N Buy streamlines sourcing so you can focus on what matters.',
  DASH_TRENDING_TITLE: 'Trending Products',
  DASH_TRENDING_SUB: 'Popular picks from buyers like you',
  DASH_MOST_POPULAR: 'Most Popular',
  DASH_LEARN_MORE: 'Learn More',
  DASH_SEE_MORE: 'See More',
  DASH_HERO_SLIDES_ARIA: 'Hero slides',
  DASH_SCROLL_TREND_LEFT: 'Scroll trending left',
  DASH_SCROLL_TREND_RIGHT: 'Scroll trending right',
  DASH_NO_PRODUCTS: 'No products',
  VIEW_QUOTE_DETAILS: 'Quote Details',
  VIEW_QUOTE_SEARCH_ITEMS: 'Search items',
  VIEW_QUOTE_NOTES: 'Notes',
  VIEW_QUOTE_ITEMS_COUNT: 'Items',
  VIEW_QUOTE_DATE_LABEL: 'Date',
  VIEW_QUOTE_NOTES_TITLE: 'Quotation notes',
  VIEW_QUOTE_NOTES_EMPTY: 'No notes for this quotation.',
  VIEW_QUOTE_NOTES_ITEM_HINT: 'Admin notes are listed per item below.',
  VIEW_QUOTE_NOTES_COMMENTS: 'Comments',
  VIEW_QUOTE_OTHER_CHARGES_TITLE: 'Other Charges Breakdown',
  VIEW_QUOTE_OTHER_CHARGES_EMPTY: 'No itemized charges recorded.',
  VIEW_QUOTE_OTHER_CHARGES_BTN: 'View other charges breakdown',
  VIEW_QUOTE_OTHER_CHARGES_NONE: 'No other charges details',
  VIEW_QUOTE_NO_ITEMS: 'No line items match your search.',
  VIEW_QUOTE_NO_ITEMS_AT_ALL: 'No line items yet.',
  VIEW_QUOTE_LINE_TOTAL: 'Line total',
  VIEW_QUOTE_ETA: 'ETA',
  VIEW_QUOTE_CURRENCY: 'Currency',
  VIEW_QUOTE_UPDATE_TITLE: 'Update Quote',
  VIEW_QUOTE_UPDATE_BODY_P1: 'Changes that have been made require requoting from admin.',
  VIEW_QUOTE_UPDATE_BODY_P2: 'A request will be sent to admin. They will review the details and will notify you as soon as your quote is ready.',
  VIEW_QUOTE_UPDATE_BODY_P3: 'Do you wish to continue?',
  VIEW_QUOTE_UPDATED_SUCCESS_TITLE: 'Your quote has been updated',
  VIEW_QUOTE_UPDATED_SUCCESS_BODY:
    "A request has been sent to admin. We're reviewing the details and will notify you as soon as your quote is ready.",
  VIEW_QUOTE_CANCEL_EDIT_TITLE: 'Cancel Edit',
  VIEW_QUOTE_CANCEL_EDIT_BODY_1: 'No changes will be saved if you cancel.',
  VIEW_QUOTE_CANCEL_EDIT_BODY_2: 'Do you want to continue?',
  VIEW_QUOTE_FOLLOW_EUR: 'Following price is in EUR',
  VIEW_QUOTE_USE_CANCEL_END_EDIT: 'Use Cancel below to stop editing.',

  PENDING_ACTIONS_TITLE: 'Pending Actions',
  PENDING_ACTIONS_DETAIL_ARIA: 'Pending actions detail',
  PENDING_ACTION_DRAFT_STRIP: 'You Have A Saved Draft',
  PENDING_ACTION_DRAFT_TITLE: 'You Have A Saved Draft',
  PENDING_ACTION_DRAFT_DESC: 'Finish and submit your request to get a quote',
  PENDING_ACTION_DRAFT_CTA: 'Continue Draft',
  PENDING_ACTION_WIRE_STRIP: 'Complete your payment to keep things moving',
  PENDING_ACTION_WIRE_TITLE: 'Complete Your Payment To Keep Things Moving',
  PENDING_ACTION_WIRE_DESC_WITH_ID: 'Your Order {id} is pending a wire transfer',
  PENDING_ACTION_WIRE_DESC: 'You have an order pending a wire transfer',
  PENDING_ACTION_WIRE_CTA: 'View Payment Details',
  PENDING_ACTION_CC_STRIP: "Payment didn't go through",
  PENDING_ACTION_CC_TITLE: "Payment didn't go through",
  PENDING_ACTION_CC_DESC_WITH_ID:
    'Order {id}: payment did not go through. Please check your details or try again to continue.',
  PENDING_ACTION_CC_DESC:
    'No worries, it happens! Please check your details or try again to continue.',
  PENDING_ACTION_CC_CTA: 'Update Payment Details',
  PENDING_ACTION_PROFILE_STRIP: 'Complete your profile',
  PENDING_ACTION_PROFILE_TITLE: 'Complete profile',
  PENDING_ACTION_PROFILE_DESC: 'Just one more step, complete your profile to start quoting.',
  PENDING_ACTION_PROFILE_CTA: 'Complete Profile',

}


const SpanishLanguage = {
  Payment_Cancelled2:'No se ha deducido ningún importe de su cuenta.',
  Payment_Cancelled1:'Canceló el proceso de pago.',
  Payment_Cancelled: 'Pago cancelado',
  Payment_Failed: 'Pago rechazado',
  Payment_Failed1: 'No se pudo procesar el pago con tarjeta.',
  Payment_Failed2: 'El pedido se guardó con estado de pago rechazado. Puede reintentar desde Mis pedidos.',
  QUESTIONONE:'P1. ¿Cómo calificarías tu experiencia de compra?',
  QUESTIONTWO:'P2. ¿El producto recibido corresponde a lo que buscaba?',
  QUESTIONTHREE:'P3. ¿Cómo calificarías tu experiencia en el proceso de pago?',
  QUESTIONFOUR:'P4. Agradecemos que nos deje una reseña de su experiencia de compra general.',
  SURVEY_REVIEW_PLACEHOLDER: 'Cuentanos tu experiencia.',
  SURVEY_SEND: 'Enviar',
  GIVE_SURVEY: "Participar en una encuesta",
  SURVEY_TITLE:"Estamos aquí para ayudarte. Envíanos un mensaje y te responderemos lo antes posible.",
  overall_experience:'Responda todas las preguntas antes de enviar la encuesta.',
  SURVEY:'Encuesta',
  SURVEY_MESSAGE:"¿Quieres participar en una encuesta?",
  SAVE:'Guardar',
  CATEGORY_SELECTION: "Administrar categoría",
  PRIZEMESSAGE:'El siguiente precio está en USD',
  CATEGORY_SELECT_MESSAGE:'Por favor seleccione la categoría que más le interese (una o más)',
  SELECT_CATEGORY_TITLE: 'Seleccione una categoría',
  SELECT_CATEGORY_SUBLINE_1: 'Elija una o más categorías que le interesen',
  SELECT_CATEGORY_SUBLINE_2: 'Puede seleccionar categorías más tarde en la configuración',
  SKIP: 'OMITIR',
  CATEGORY_SELECT_ERROR:'Seleccione al menos una categoría para continuar.',
  HOME:'Inicio',
  CAETGORY_LIST:'Listado de categorías',
  CC:'TC',
  WT:'TB',
  NEW_Progress:'Cotizado',
  NEW_PENDING :'Por Cotizar',
  INCORRECT_DATA:'Datos incorrectos',
  INCORRECT_TEXT:'Las solicitudes de cotización para los siguientes productos no se envían al administrador. Puede solicitar una cotización para estos productos desde Mis cotizaciones.',
  BULK_REQUEST_TEXT:'Solicitud masiva mediante Excel',
  REFUND:'Integrado',
  MESSAGE_FOR_PRODUCT:'¿Podrías confirmarme primero si has realizado algún cambio?',
  CONFIRMA : 'Confirmar',
  BULK_PERA:"Descargue la plantilla de Excel, complete los detalles necesarios, cárguela y envíela para recibir una cotización de productos al por mayor.",
  NOTIFACTION_THIRD:'Puede continuar solicitando una cotización mediante Ingreso Manual o Carga Masiva cuando esté listo.',
  USERNAME:'Nombre de Usuario',
  NOTIFACTION_FIRST_DESC:'Nos alegra ver que ha creado una cuenta con nosotros. Aquí puedes solicitar una cotización para cualquier cosa.Revisaremos su solicitud y le proporcionaremos una cotización lo antes posible. Aquí tienes las credenciales de tu cuenta y recuerda tenerlas a mano.',
  NOTIFACTION_TITAL:'¡Bienvenido a Quote & y Buy!',
  TRACKING:'Seguimiento',
  ARE_YOU_SURE_UPDATE:'¿Está seguro que desea continuar sin hacer ningún otro cambio?',
  UPDATE:'Actualizar',
  BY:"Por",
  NEW_QTY:'Nueva cantidad',
  SEEPREVIEW:'Ver Vista previa',
  IMPORT:"Importar",
  BACK:"Atras",
  ORDERQUOTATIONID: 'ID Cot',
  IAGREEWITH: "Estoy de acuerdo con",
  SELECT_METHOD:'Por favor seleccione el método de entrada y continúe',
  NEW_REQUEST_QUOTES: "SOLICITUD DE NUEVA COTIZACIÓN",
  ENTER_YOUR_LOGIN_DETAILS: 'Ingrese sus datos para iniciar sesión',
  LOGIN_WITH:'O Iniciar sesión con',
  SINGUP_WITH:'O regístrate con',
  GUEST_USER:'Continuar como',
  GUEST:'Invitado',
  PRIVACY_POLICY: 'Políticas de Privacidad',
  Condition: 'Condición',
  TERMS_SINGUP: 'Términos',
  ACCPET: "Aceptar",
  HAVE_ACCOUNT: 'Ya tienes una cuenta',
  ENTER_YOUR_DETAILS: 'Ingrese sus datos para crear su cuenta',
  Confirm_Password: 'Confirmar Contraseña',
  RESET_PASSWORD: 'Restablecer contraseña',
  VERIFY: 'Verificar',
  RESEND_OTP: 'Reenviar OTP',
  RESEND_IN: 'Reenviar en',
  DONT_RECIVE_CODE: `No recibí el código`,
  ENTER_OTP_DIGIT: 'Ingrese la OTP de 4 dígitos enviada a',
  OTP_VERIFICATION: 'Verificación OTP',
  SEND_OTP: 'Enviar OTP',
  SINGUP: 'Regístrate',
  LOGIN_MESSAGE: '¿No tienes una cuenta?',
  FORGOT_PASSWORD: "¿Olvidaste tu contraseña",
  REMEBER_ME: 'Recuérdame',
  LOGIN_EMAIL_ADDRESS: "Correo Electrónico",
  LOGIN_EMAIL_ADDRESS_TEXT: "Introduzca la dirección de correo electrónico",
  Item: 'Item',
  EXCLSUBMIT: "Solicitar Cotización",
  VALIDIMAGE: "Por favor, cargue una imagen y un vídeo válidos.",
  IMAGE1: "Imagen 1",
  IMAGE2: "Imagen 2",
  IMAAGE_VIDEO: 'Puedes subir un máximo de dos archivos: una foto y un vídeo o dos fotos.',
  IMAGE_VIDEO_SIZE_ERROR: 'El tamaño del archivo excede el límite máximo de 25 MB.',
  MAX_VIDEO_LIMIT_ERROR: 'Puedes subir solo un video a la vez.',
  DESC_NAME_REQUIRD: 'Se requiere descripción',
  SPA: "ESP",
  ENGLISH: 'English',
  SPANISH: 'Español',
  Charges_reason: 'Razón de los cargos',
  EXTED_PRICE: 'Precio extendido',
  UNIT: 'Unidad',
  Item_Name: 'Nombre del Item',
  BRAND: 'Marca',
  DAYS: 'DÍAS',
  ORDER_QTY: 'Cantidad',
  LETS_GO: '¡Vamos!',
  DOWNLADAPP: 'Descargar aplicación',
  ENTER_TIME_QUNTITY: 'Por favor ingrese la cantidad',
  ENTER_TIME_QUNTITY_NUMBER: 'Por favor ingrese solo el número',
  HISTORY: 'Historia',
  EXCHANGE: 'Intercambio',
  SEND_UPDATE_REQUEST: 'Enviar cantidad actualizada',
  EDIT_QUANTITY: 'Editar cantidad',
  WRITE: 'Escribir',
  OTHER_BRAND: 'Otra marca',
  VIEW: 'Vista',
  VIEW_ALL: 'Ver todo',
  PRE_PRODUCT_PRICE: 'precio unitario',
  DOWNLOAD_PDF: 'Descargar Pdf',
  UPLOAD: 'Subir archivos',
  PHOTOS_VIDEO: 'Foto o vídeo',
  INSTRUCTIONS: 'Instrucciones de entrega (Opcional)',
  ENTER_INSTRUCTIONS: "Ingrese Los instrucciones para la entrega",
  REQUIRED_LOACTION: 'Por favor seleccione el tipo de ubicación',
  RESIDENTIAL: 'Residencial',
  LABORAL: 'Laboral',
  LOACTION_TYPE: 'Tipo De Domicilio',
  TRAKING_NUMBER: 'El número de rastreo',
  AWB_NUMBER: 'Número AWB',
  WAYBILLNUMBER: 'Número de carta de porte',
  SHIPPINSCompany: 'Compañía naviera',
  TRAKING_URL: 'URL de seguimiento',
  SHPPING_DEATILS: "Detalles de envío",
  ORDER_SHIPPING_MODAL_TITLE: "Envío",
  ORDER_SHIPPING_COMPANY_LABEL: "Empresa",
  ORDER_TRACKING_NUMBER_HASH: "Número de seguimiento#",
  ORDER_SPECIAL_INSTRUCTIONS: "Instrucciones especiales",
  CHANGE_ADDRESS_DES: 'Si cambia la dirección, la cotización actual no será válida y la solicitud se enviará nuevamente al administrador.',
  CHANGE_ADDRESS: 'Cambiar dirección',
  VALID_PHONE_NUMBER: "El número de teléfono debe tener al menos 7 números.",
  PHONE_MAX_CHAR: "El número de teléfono no puede exceder los 15 números.",
  PHONE_NUMBER_VALID: "El número de móvil introducido no es válido, inténtalo de nuevo.",
  VALID_PHONE: 'Por favor ingresa un número de teléfono válido',
  EMAIL_ADDRESS: 'Por favor ingrese una dirección de correo electrónico válida.',
  EMAIL_MAX: 'El correo electrónico no puede exceder más de 150 caracteres.',
  EMAIL_MIN: 'El correo electrónico debe tener al menos 3 caracteres.',
  PLEASE_ENTER_Email: 'Por favor ingrese su correo electrónico',
  NAME_MAX: 'El nombre no puede exceder más de 25 caracteres.',
  NAME_MIN: 'El nombre debe tener al menos 3 caracteres.',
  PLEASE_ENTER_NAME: 'Por favor ingresa tu nombre',
  STREET_LINE_OTHER: "La línea de la calle no puede contener espacios consecutivos",
  STREET_LINE_CONTACT_DES_MAX: 'la línea de la calle no puede exceder más de 250 caracteres',
  STREET_LINE_DES_MIN: 'La línea de la calle debe tener al menos 3 caracteres.',
  STREET_LINE: 'Por favor ingrese su línea de calle',
  SELECT_EXCEL: "Por favor seleccione el archivo excel",
  ENTER_PASSWORD: "Por favor ingrese la contraseña",
  Emojis: 'Emojis no permitidas',
  DES_LINE: 'La línea descriptiva no puede contener espacios consecutivos.',
  DES_MIN: 'La descripción debe tener al menos 3 caracteres.',
  CONTACT_DES_MAX: 'La descripción no puede exceder los 500 caracteres.',

  ENTER_DESC: "Por favor ingresa tu descripción",
  PASSWORD_CONFIRM_PASSWORD_MUST_MATCH: "La nueva contraseña y la contraseña de confirmación deben ser Los mismas",
  CONFIRM_PASSWORD_MIN_CHAR: "La contraseña de confirmación debe tener al menos 8 caracteres.",
  CONFIRM_PASSWORD_MAX_CHAR: "Confirmar contraseña no debe exceder los 16 caracteres",
  NEW_PASSWORD_REQUIRED: "Por favor ingrese una nueva contraseña.",
  NEW_PASSWORD_MIN_CHAR: "La nueva contraseña debe tener al menos 8 caracteres.",
  NEW_PASSWORD_MAX_CHAR: "La nueva contraseña no debe exceder los 16 caracteres",

  CONFIRM_NEW_PASSWORD_REQUIRED: "Por favor ingrese confirmar contraseña.",
  CONFIRM_NEW_PASSWORD_MIN_CHAR: "La contraseña para volver a ingresar debe tener al menos 8 caracteres.",
  CONFIRM_NEW_PASSWORD_MAX_CHAR: "Volver a ingresar la contraseña no debe exceder los 16 caracteres.",
  // PASSWORD_CPWD_NOT_MATCHED: "Entered password doesn't match. please try again",
  PASSWORD_CPWD_NOT_MATCHED: "La nueva contraseña y Confirmar contraseña no coinciden.",
  PASSWORD_OLD_NOT_SAME: "Ya has utilizado esta contraseña antes, establece otra contraseña",

  NEW_OLD_PASSWORD_SAME: 'La nueva contraseña no puede ser la misma que la antigua',
  PASSWORD_MATCH: "La contraseña debe tener entre 8 y 15 caracteres y debe contener al menos una mayúscula, una minúscula, un número y un carácter especial.",
  PASSWORD_VALID: "La contraseña debe contener caracteres alfanuméricos que incluyan al menos 1 carácter en mayúscula y 1 carácter especial.",
  PASSWORD_UPPER_CASE: "La contraseña debe contener caracteres alfanuméricos que incluyan al menos 1 carácter en mayúscula y 1 carácter especial.",
  PASSWORD_SPECIAL_CASE: "La contraseña debe contener caracteres alfanuméricos que incluyan al menos 1 mayúscula, 1 minúscula y 1 carácter especial.",
  PASSWORD_NUMBER_CASE: "La contraseña debe contener caracteres alfanuméricos que incluyan al menos 1 carácter en mayúscula y 1 carácter especial.",

  REQUIRED: "Requerido",
  PASSWORD_REQUIRED: "Por favor ingrese la contraseña.",
  CONFIRM_PASSWORD_REQUIRED: "Por favor ingrese confirmar contraseña.",
  NO_SPACE_ALLOWED: "No se permite espacio.",
  OLD_PASSWORD_REQUIRED: "Por favor ingrese la contraseña anterior.",
  OLD_PASSWORD_MIN_CHAR: "La contraseña anterior debe tener al menos 8 caracteres.",
  OLD_PASSWORD_MAX_CHAR: "La contraseña anterior no debe exceder los 16 caracteres.",
  EXCEED: "no puede exceder más de",
  MAX: 'debe ser al menos',
  PLEASE_SELECT: 'Por favor seleccione su',
  PLEASE_ENTER: 'Por favor ingrese su',
  VERFIY_EMAIL: 'Por favor verifique su correo electrónico',
  OTHER_MAX: "El nombre de otra marca no puede exceder los 50 caracteres.",
  OTHER_MIN: "Otra marca mínimo 1 palabra",
  OTHER_BRAND_REQUIRED: "Se requiere otra marca",
  MODAL_MAX: "El número de modelo no puede exceder los 50 caracteres",
  SER_MAX: "El número de serie no puede exceder los 50 caracteres",
  DES_MAX: 'La descripción debe tener como máximo 250 caracteres.',
  QUNTITY_NUMBER: "Por favor ingrese solo el número",
  QUNTITY_MAX: 'La cantidad no puede exceder 1000000',
  QUNTITY_MIN: 'La cantidad debe ser al menos 1',
  QUNITYTY_REQUIRED: "Se requiere cantidad",
  PART_NUMBER_MAX: 'El número de pieza no puede exceder los 50 caracteres',
  PART_NUMBER_MIN: 'El número de pieza debe tener al menos 1 carácter',
  PART_NUMBER_REQUIRED: 'Se requiere el número de pieza',
  BRAND_NAME_REQUIRD: 'Se requiere el nombre de la marca',
  BRAND_NAME_ALREDY: 'El nombre de la marca ya existe.',
  PLEASE_SELECT_SHIPPING_TYPE: 'Por favor seleccione el método de envío',
  PLEASE_SELECR_DELIVER_ADDRESS: 'Por favor seleccione la dirección de entrega',
  PLEASE_SELECT_TYPE: 'Por favor seleccione un tipo',
  CONFIRMA_PASSWORD: 'Confirmar nueva contraseña',
  NEW_PASSWORD: 'Nueva contraseña',
  OLD_PASSOWRD: 'Contraseña anterior',
  ORDER_FILLTER_INPUT: "Buscar por ID de pedido..",
  ORDER_SEARCH_QUOTE_ID: "Buscar por el ID del pedido.",
  ORDER_PAYMENT_WT_PENDING: "Transferencia bancaria pendiente",
  ORDER_PAYMENT_WT_REFUND_PENDING: "Reembolso TB pendiente",
  ORDER_PAYMENT_DECLINED: "Rechazado",
  CONTINUE_TO_PAYMENT: "Continuar al pago",
  ORDER_COL_ORDER_STATUS: "Estado del pedido",
  ORDER_COL_PMT_STATUS: "Estado PMT.",
  ORDER_COL_MSG: "Msj",
  ORDER_DETAILS_HEAD: "Detalles del pedido",
  ORDER_DETAIL_TABLE_PART_HASH: "N.º de pieza",
  ORDER_DETAIL_TABLE_SERIAL_HASH: "N.º de serie",
  REJECT_QUTO: "¿Quieres rechazar esta cotización?",
  REQUESTQUOTE: 'Solicitar Cotización',
  CUSTOMER_PURCHASED: "Los clientes también han comprado",
  BRAND_NAME: 'Nombre de la marca',
  MYADDRESS: "Mis direcciones",
  ADDRESS_EMPTY_STATE_MESSAGE:
    "Parece que aún no has agregado una dirección. Agrega una ahora para empezar a cotizar.",
  UPDATEADDRES: "ACTUALIZAR DIRECCIÓN",
  OTHER_BRAND_NAME: 'Otra Nombre de la marca',
  YOU_WANT_TO_DELETE: '¿Estás seguro de que quieres eliminar tu cuenta?',
  YOU_WANT_TO_DELETE_NOTIFICATION: '¿Desea eliminar esta notificación?',
  YOU_WANT_TO_DELETE_ALL_NOTIFICATION: '¿Desea eliminar todas las notificaciones?',
  REMOVE_PRODUCT: 'Eliminar',
  PRODUCT_DELETE_MESSAGE: 'Si elimina los productos, se enviará una solicitud al administrador para su aprobación. El producto sólo se eliminará si el administrador aprueba la solicitud. Si la solicitud es rechazada, el producto permanecerá sin cambios. ¿Aún deseas continuar con la eliminación del producto?',
  DELETE_TITEL: 'Eliminar producto',
  EDIT_Q_MESSAGE: 'Si edita la cantidad, se enviará una solicitud al administrador para su aprobación. Los precios y la cantidad solo se actualizarán si el administrador acepta el cambio. Si se rechaza la solicitud, la cantidad y el precio permanecerán sin cambios. ¿Aún deseas continuar con la edición de la cantidad?',
  Edit_Quantity: 'Editar cantidad',
  REASON: 'Razón',
  ORDER_CANCEL_TITAL: 'Motivo de cancelación del pedido',
  CANCEL: 'Cancelar',
  ORDER_CANCEL_MESSAGE: 'La solicitud se enviará al administrador; si el administrador la aprueba, solo se realizará la cancelación.',
  ORDER_CANCEL: 'Cancelar pedido',
  GO_TO_HOME: 'Ir al Inicio',
  ORDER_LINE_ONE: 'Su pedido ha sido realizado con éxito',
  ORDER_SUCCESS_TITLE: '¡Su pedido se ha realizado con éxito!',
  ORDER_SUCCESS_DESC:
    'Gracias por su compra. Su pedido está siendo procesado y recibirá un correo de confirmación con todos los detalles en breve.',
  ORDER_SUCCESS_WIRE_DESC:
    'Se ha enviado un correo electrónico con la información para realizar el pago mediante transferencia bancaria. Una vez que recibamos los fondos procederemos con su pedido.',
  ORDER_LINE_SEC: 'Su pedido está en proceso, esto no es una factura: Se ha enviado un correo electrónico con la información para realizar el pago mediante transferencia bancaria. Una vez que recibamos los fondos procederemos con su pedido.',

  Successful: 'Exitosa',
  SELETE_PAYMENT_ERROR: 'Por favor seleccione método de pago',
  PLACE_ORDER: 'Proceder con el Pago',
  ONLINE: 'En Línea',
  OFFLIE: 'Transferencia Bancaria',
  PAYMENT_MATHOD: 'Método de pago',
  NET_ORDER_AMOUNT: 'Monto neto del pedido',
  OTHER_CARGERS: 'Otros cargos',
  TOTAL_TAX_AMOUNT: 'Monto total del impuesto',
  EDIT: 'Editar',
  ADDRESS: 'DIRECCIÓN',
  MOBILE: 'Móvil',
  CHECKOUT: 'Verificar',
  PASSWORD: 'Contraseña',
  DELETE_ACCOUNT: 'Eliminar cuenta',
  DELETE_ALL: 'Eliminar todo',
  YES: 'Sí',
  NO: 'No',
  YOU_WANT_TO_LOGUT: '¿Estás seguro de que quieres cerrar sesión?',
  ARE_YOU_SURE: 'Estás Seguro',
  PRICE_BRACKDOWN: 'Desglose de precios',
  PAID: 'Pagado',
  VIEW_HISTORY: 'Ver Historial',
  DATETYPE: "MM/DD/AAAA",
  MESSAGEDATA: 'Buscar por Id. de cita',
  TO: "A",
  FROM: 'De',
  SHIPPING_DETAILS: "Detalles de envío",
  ORIGNAL_REQUEST: 'Solicitud original',
  REVISION: 'Revisión',
  LATEST_REVISION: 'Última revisión',
  PRODUCT_REVISON_HISTORY: "Historial de revisiones del producto",
  PRODUCT_HISTORY: 'Historia del producto',
  Approve: 'Aprobar',
  Reject: 'Rechazar',
  TOTAL_PRODUCT_PRICE: "Precio total del producto",
  TOTAL_SHPPINGH: 'Envío total',
  SHIPPINGPRICE: 'Precio de envío',
  PERPIUCESPRICE: "Precio por pieza",
  SHIPPINGTYPE: "Tipo de envío",
  EDITQUANTITY: 'Confirmar Cambio',
  SEND: 'Enviar',
  MESSAGE: "Mensaje",
  Contact_Us: "Contáctanos",
  ENTER_ZIP_CODE: "Ingrese el código postal",
  ZIP_CODE: "Código postal",
  ENTER_CITY: "Introduce la ciudad",
  CITY: "Ciudad",
  ENTER_STATE: "Ingresar estado",
  STATE: "Estado",
  ENTER_APARTMENT: "Entrar apartamento",
  APRATMENT: "apartamento",
  ENTER_STREE_LINE: "Ingrese la línea de la calle",
  STREE_LINE: "Línea de calle",
  SELETE_ADDRESS: "Seleccionar dirección",
  ENTER_EMAIL_ID: "Ingrese su ID de correo electrónico",
  ENTER_FULL_NAME: "Ingrese el nombre completo",
  UPDATE_PROFILE: "Actualizar perfil",
  PHONE_NUMBER: "Número de teléfono",
  EMAIL_ID: "ID de correo electrónico ",
  NAME: "Nombre",
  MY_PROFILE: "Mi perfil",
  EDIT_PHOTO: "Editar foto",
  PLEASE_ENTER_QUNTITY: "Por favor ingrese cualquier cantidad de producto",
  MORE: "Más",
  DATANOTFOUND: 'Datos no encontrados',
  NO_QUOTE_DATA: 'Sin datos de cotización',
  NO_ORDER_DATA: 'Sin datos de pedido',
  NO_REQUEST_FOUND: 'No se encontró ninguna solicitud.',
  ADDMOREPRODUCT: "Agregar otro Item",
  CHAT: "Charlar",
  NOTIFACTION: "Notificaciones",
  NOTIF_TODAY: "Hoy",
  NOTIF_THIS_WEEK: "Esta semana",
  NOTIF_EARLIER: "Anterior",
  NOTIF_SEE_ALL: "Ver todo",
  CONVERTINPISO: 'Convertir precio en euros',
  GRANDTOTAL: 'Gran total',
  TOTALTAX: 'Impuesto total',
  TOTALSHIIPNGAMOUNT: 'Precio de envío',
  TOTALPRODUCTAMOUNT: 'Precio total del producto',
  PROVIDEDQUOTATION: 'Detalles de la cotización',
  ORRDERDELIVERYADDRESS: 'Dirección de entrega',
  DELIVERYSTATUS: 'Estado',
  PAYMENTSTATUS: 'Pago',
  ORDERID: 'ID Pedido',
  CANVELLED: 'Cancelado',
  DELIVERD: 'Entregado',
  INTRANSIT: 'En Transito',
  ORDERLIST: 'Lista de pedidos',
  QDATE: 'Fecha de cotización',
  SHIPINNG: 'Método de envío',
  DELADDRESS: 'Dirección de entrega',
  ACTION: "Acción",
  TOTAL: 'Total',
  NET: "Neto",
  TAX: 'Impuesto',
  AMOUNT: "Cantidad",
  CHARGES: 'Cargos',
  OTHER: 'Otros',
  PRICE: 'Precio',
  SHIPPING: 'Envío',
  STATUS: 'Estado',
  DATE: 'Fecha',
  QUOTATIONID: 'ID de cotizacion',
  SNO: 'S. No',
  REJECT: 'Rechazada',
  APPROVED: 'Aprobado',
  Progress: 'En proceso',
  PENDING: 'Pendiente',
  ALL: 'Todo',
  Filter: 'Filtrar',
  Reset: 'Reiniciar',
  QUOTATIONSLIST: 'Cotizaciones',
  PROFILE: 'Perfil',
  MYQUOTATIONS: 'Mis Cotizaciones',
  UploadExcel: 'Subir Excel',
  TEMPLATE: 'Plantilla Excel',
  Download: 'Descargar',
  SUBMIT: "Entregar",
  ADDMORE: 'Agregar nuevo Item',
  REMOVE: 'Eliminar',
  Photo: 'Foto',
  Video: 'Video',
  TWOBYTWO: 'dos fotos',
  ONEBYONE: 'Una foto y un vídeo',
  UPLOADMEDIA: 'Foto o vídeo',
  MODELNUMBER: ' Modelo',
  SERIALNUMBER: 'Serie #',
  DESCIPTIONDETAILS: 'Escribe una descripción detallada',
  Description: 'Descripción',
  ENTERDESCIPTION: 'Ingresar descripción',
  QUANTITY: 'Cantidad',
  ENTER: 'Ingresar',
  PARTNAME: 'N° Parte',
  PARTNAMEFULL: 'Número de parte',
  SELECTBRAND: 'Seleccionar marca',
  BRANDNAME: "Marca",
  NEXT: "Siguiente",
  SAVE_FOR_LATER: "Guardar para más tarde",
  SAVE_FOR_LATER_MIN_ENTRY:
    "Complete al menos un campo del Item en la pestaña de entrada de datos antes de guardar en borradores.",
  SAVE_FOR_LATER_HINT_TITLE: "Casi listo",
  GOT_IT: "Entendido",
  REVIEW: "Revisar",
  REQUEST_A_QUOTE: "Solicitar cotización",
  BULK_ENTRY_NAV: "Carga masiva",
  BULK_ENTRY_TAGLINE:
    "Para pedidos con varios artículos, la carga masiva es más rápida y sencilla.",
  BULK_DOWNLOAD_CARD_TITLE: "Descargar plantilla Excel",
  BULK_REDOWNLOAD_CARD_TITLE: "Volver a descargar plantilla Excel",
  BULK_DOWNLOAD_CARD_SUB: "Obtenga la plantilla para completar sus artículos.",
  BULK_UPLOAD_CARD_TITLE: "Subir archivo Excel",
  BULK_UPLOAD_CARD_SUB: "Haga clic para subir la plantilla completada.",
  BULK_UPLOAD_UPLOADED_CARD_TITLE: "Archivo Excel subido",
  BULK_UPLOAD_REPLACE_FILE: "Reemplazar archivo Excel",
  BULK_DELETE_UPLOADED_FILE: "Eliminar archivo subido",
  BULK_REMOVE_UPLOAD_TITLE: "Quitar carga",
  BULK_REMOVE_UPLOAD_LINE1: "¿Desea reemplazar este archivo?",
  BULK_REMOVE_UPLOAD_LINE2: "Podrá subir uno nuevo una vez eliminado.",
  BULK_REMOVE_UPLOAD_KEEP: "Mantener",
  BULK_REMOVE_UPLOAD_REMOVE: "Eliminar",
  BULK_PREVIEW_FILE_SHORT: "Vista previa",
  POPUP_BLOCKED: "Permita las ventanas emergentes para abrir el archivo en una pestaña nueva.",
  BULK_PREVIEW_UPLOADED_FILE: "Vista previa del archivo subido",
  BULK_EXCEL_FILE_PREFIX: "Archivo Excel",
  BULK_EXCEL_ENTER_DATA: "Información incorrecta proporcionada en la hoja de Excel.",
  BULK_EXCEL_INVALID_HEADER: "Por favor ingrese un formato de hoja de Excel válido.",
  BULK_SHIPPING_PREFS_SAVED: "Preferencias guardadas.",
  BULK_SET_PRIMARY_ADDRESS: "Establecer como dirección principal",
  WIZARD_STEP_DATA_ENTRY: "Entrada de datos",
  WIZARD_STEP_SHIPPING: "Envío",
  WIZARD_STEP_REVIEW: "Revisión",
  GRID_VIEW: "Vista de cuadrícula",
  LIST_VIEW: "Vista de lista",
  TABLE_VIEW: "Vista de tabla",
  MANUAL_QUOTE_DELIVERY_SECTION: "Dirección de entrega",
  MANUAL_QUOTE_RESIDENCE: "Tipo de residencia",
  MANUAL_QUOTE_SELECT_RESIDENCE: "Seleccione tipo de residencia",
  MANUAL_QUOTE_BILLING_SAME: "La dirección de facturación es la misma que la de envío",
  MANUAL_QUOTE_SHIPPING_METHOD_SECTION: "Método de envío",
  MANUAL_QUOTE_PLACEHOLDER_ADDRESS_LINE: "Introduzca la dirección",
  MANUAL_QUOTE_PLACEHOLDER_INSTRUCTIONS: "Introduzca instrucciones",
  MANUAL_QUOTE_SHIPPING_DETAILS: "Detalles de envío",
  MANUAL_QUOTE_INSTRUCTIONS: "Instrucciones de entrega (opcional)",
  ADDRESS_LINE_1: "Dirección línea 1",
  ADDRESS_LINE_2: "Dirección línea 2",
  PART_NUMBER_HASH: "Pieza #",
  QTY_SHORT: "Cant.",
  SKU_LABEL: "SKU",
  UPLOAD_IMAGES: "Subir archivos",
  MANUAL_QUOTE_CHIP_IMAGE_1: "Imagen 1",
  MANUAL_QUOTE_CHIP_IMAGE_2: "Imagen 2",
  MANUAL_QUOTE_CHIP_VIDEO: "Video",
  MANUAL_QUOTE_REVIEW_PART_NUMBER: "Número de pieza",
  MANUAL_QUOTE_REVIEW_SERIAL_NUMBER: "Número de serie",
  DISPLAY_VALUE_NA: "N/D",
  ADD_ITEM_PLUS: "Añadir Item",
  DRAFT_SAVED: "Se guardó su progreso. Puede continuar más tarde desde Solicitar cotización.",
  DRAFT_SAVED_LIST: "Guardado en borradores. Abra Borradores en el menú para continuar, editar o eliminar.",
  MANUAL_DRAFTS_PAGE_HEADING: "Borradores guardados",
  MANUAL_DRAFTS_PAGE_SUB: "Solicitudes de cotización manual guardadas con Guardar para más tarde.",
  MANUAL_DRAFTS_DEVICE_SECTION: "En este dispositivo",
  MANUAL_DRAFTS_ACCOUNT_SECTION: "Guardados en su cuenta",
  MANUAL_DRAFTS_LOADING_ACCOUNT: "Cargando borradores de la cuenta…",
  MANUAL_DRAFTS_EMPTY: "Aún no hay borradores. Inicie una cotización manual y use Guardar para más tarde.",
  MANUAL_DRAFTS_COL_PREVIEW: "Vista previa del borrador",
  MANUAL_DRAFTS_COL_SAVED: "Fecha",
  MANUAL_DRAFTS_META_DATE: "Fecha",
  MANUAL_DRAFTS_COL_ITEMS: "Items",
  MANUAL_DRAFTS_COL_STEP: "Paso",
  MANUAL_DRAFTS_STEP_1: "Items",
  MANUAL_DRAFTS_STEP_2: "Envío",
  MANUAL_DRAFTS_STEP_3: "Revisar",
  MANUAL_DRAFTS_UNTITLED: "Borrador de cotización",
  MANUAL_DRAFTS_DELETE_CONFIRM_TITLE: "¿Eliminar este borrador?",
  MANUAL_DRAFTS_DELETE_CONFIRM_TEXT: "No podrá recuperarlo.",
  MANUAL_DRAFT_DELETED: "Borrador eliminado.",
  MANUAL_DRAFTS_NEW_QUOTE: "Nueva cotización",
  BUSINESS_PROFILE_GATE_TITLE: "Complete el perfil de su empresa",
  BUSINESS_PROFILE_GATE_TEXT:
    "Las cuentas empresa deben completar el perfil antes de solicitar una cotización. Actualice su perfil para continuar.",
  BUSINESS_PROFILE_REQUIRED_TOAST: "Complete el perfil de su empresa antes de solicitar una cotización.",
  SAVE_FOR_LATER_CONFIRM_TITLE: "¿Guardar en borradores?",
  SAVE_FOR_LATER_CONFIRM_TEXT: "Se guardará su progreso y pasará a la pantalla Borradores para revisar o continuar más tarde.",
  SAVE_FOR_LATER_CONFIRM_HTML:
    "Su solicitud se guardará y será redirigido a sus borradores.<br/><br/>¿Desea continuar?",
  QUOTE_REQUEST_SENT_TITLE: "Solicitud enviada",
  QUOTE_REQUEST_SENT_HTML: "Su solicitud fue enviada al equipo. Volviendo al inicio en unos segundos…",
  QUOTE_SUCCESS_THANK_YOU: "Gracias por cotizar con nosotros",
  QUOTE_SUCCESS_RECEIVED: "Su solicitud ha sido recibida",
  QUOTE_SUCCESS_REVIEWING: "Estamos revisando los detalles y le notificaremos tan pronto como su cotización esté lista",
  MANUAL_QUOTE_CLOSE_PREVIEW: "Cerrar",
  MANUAL_QUOTE_COMPLETE_ITEMS: "Complete todos los campos obligatorios de los Items antes de continuar.",
  MANUAL_QUOTE_COMPLETE_SHIPPING_TAB: "Seleccione dirección de entrega y método de envío antes de Revisar.",
  MANUAL_QUOTE_FIRST_ADDRESS_INTRO:
    "Complete el formulario para guardar su primera dirección de entrega. Después podrá gestionarla y añadir más cuando quiera.",
  NEWADDRES: "Añadir Nueva Dirección",
  SHIPPINGMETHOD: 'Seleccione método de envío',
  DELIVERYADDRESS: 'Seleccionar dirección de entrega',
  COUNTINUE: "Continuar",
  EXCEL: 'Carga Masiva',
  EXCEL_DESC: 'Suba un archivo Excel usando nuestra plantilla',
  BULKREQUEST: "Solicitud masiva a través de",
  QUOTATIONFORM: 'Ingreso Manual',
  QUOTATIONFORM_DESC: 'Ingrese los detalles del producto uno por uno',
  REQUESTVIA: 'Solicitar vía',
  PRODUCTLISTING: "Listado de productos",
  CONTACTUS: "Contáctanos",
  FOOTER_TRENDING_PRODUCTS: "Productos en tendencia",
  FOOTER_CONTACT_SUPPORT: "Contactar soporte",
  CONTACT_SUPPORT_LEAD: "Estamos aquí para ayudarte. Envíanos un mensaje y te responderemos.",
  CONTACT_SUPPORT_MSG_PLACEHOLDER: "Cuéntanos qué ocurre. Cuantos más detalles, mejor.",
  CONTACT_SUPPORT_CHAR_COUNT: "Recuento de caracteres",
  CONTACT_SUPPORT_THANKS: "¡Gracias! Tu mensaje se ha enviado.",
  CONTACT_SUPPORT_CLOSE_HINT: "Puedes cerrar esta pestaña o volver al sitio.",
  CONTACT_SUPPORT_BACK_HOME: "Volver al inicio",
  CONTACT_SUPPORT_CLOSE_ARIA: "Cerrar",
  PRODUCTSUGGESTIOND: "Sugerencias de productos",
  REQUESTQUOTES: "Iniciar cotización",
  ABOUTUS: 'Sobre nosotros',
  TESTIMONIAL: "Testimonios",
  CLIENTREVIEW: '¿Qué dicen Los clientes felices de nosotros?',
  PRIACYPOLICY: "Política de Privacidad",
  TERMS: 'Términos y Condiciones',
  COPYRIGHT: "© 2025-2026 Cotizar y Comprar. Reservados todos los derechos.",
  FAQS: "Preguntas frecuentes",
  LOGIN: "Iniciar sesión",
  BACK_TO_LOGIN: "Volver a",
  LOGOUT: "Cerrar sesión",
  VIEWPROFILE: "Ver perfil",
  MY_DETAILS: "Mis datos",
  MYORDER: "Mis Pedidos",
  MYOUESTION: 'Mis cotizaciones',
  DRAFTS: 'Borrador',
  SETTING: 'Ajustes',
  CHANGEPASSWORD: "Cambiar la contraseña",
  CHANGE_PASSWORD_SUBTITLE: "Establezca una nueva contraseña para su cuenta",
  NOTIFIACTION: 'Configuración de notificación',
  DELETEACCOUNT: "Eliminar cuenta",
  YOU_WANT_TO_DELETE_Address: '¿Está seguro de que desea eliminar su dirección?',
  NO_SPACES_ALLOWED: 'No se permiten espacios o no pueden estar vacíos',

  OR_CONNECTOR: 'O',
  AUTH_LANGUAGE_ARIA: 'Idioma',
  ACCOUNT_TYPE: 'Tipo de cuenta',
  ACCOUNT_TYPE_INDIVIDUAL: 'Individual',
  ACCOUNT_TYPE_BUSINESS: 'Empresa',
  COMPANY_NAME_LABEL: 'Nombre de la empresa',
  COMPANY_NAME_PLACEHOLDER: 'Nombre de la empresa',
  FIRST_NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  COMPANY_EMAIL: 'Correo de la empresa',
  SIGNUP_SUBTITLE_INDIVIDUAL: 'Introduce los datos para crear una cuenta individual.',
  SIGNUP_SUBTITLE_BUSINESS: 'Introduce los datos para crear una cuenta empresarial.',
  OPTIONAL_MARK: '(Opcional)',
  OPTIONAL_MARK_FIELD: 'Opcional',
  AUTH_PROMO_TITLE: 'En Quote N Buy',
  AUTH_PROMO_TITLE_2: '¡Es muy simple!',
  AUTH_PROMO_TITLE_3: 'Sin importar peso ni tamaño',
  AUTH_PROMO_TEXT:
    'Nos especializamos en buscar y cotizar lo que necesitas, entregándolo directamente a tu puerta.',
  WESPECIALIZETEXT:
    'Nos especializamos en buscar y cotizar lo que necesitas, entregándolo directamente a tu puerta.',
  SIMPLYTEXT:
    'Simplemente dinos qué tipo de pieza es, para qué marca, cuántas necesitas y, si tienes una foto, ¡mejor! Haremos nuestro mejor esfuerzo para cotizar lo que estás buscando.',
  PERHAPSTEXT:
    'Quizás necesites equipos o repuestos para tu máquina industrial, minera, agrícola o simplemente para un hobby o proyecto en el que estás trabajando.',
  OTP_ENTER_ERROR: 'Por favor ingrese el OTP.',
  FORGOT_EMAIL_REQUIRED: 'Por favor ingrese el correo electrónico',
  FORGOT_EMAIL_INVALID: 'Por favor ingrese un correo electrónico válido',
  LANDING_NAV_WHAT: 'Qué hacemos',
  LANDING_NAV_ABOUT: 'Sobre nosotros',
  LANDING_NAV_TRUST: 'Nuestra confianza',
  LANDING_ARIA_HOME: 'Inicio Quote N Buy',
  LANDING_ARIA_MENU: 'Menú',
  LANDING_NAV_PRIMARY: 'Navegación principal',
  LANDING_HERO_TITLE_1: 'Encuentra lo que necesitas',
  LANDING_HERO_TITLE_2: 'En cualquier lugar y momento',
  LANDING_HERO_SUB:
    'Quote N Buy te conecta con proveedores globales de confianza para que obtengas productos de forma rápida, segura y con tranquilidad.',
  LANDING_HERO_ALT: 'App móvil Quote N Buy',
  LANDING_HOW_BTN: 'Cómo funciona',
  LANDING_HOW_TITLE: '¿Cómo funciona?',
  LANDING_STEP1_TITLE: 'Solicitar',
  LANDING_STEP1_DESC: 'Envía tu solicitud. Cuéntanos qué buscas.',
  LANDING_STEP2_TITLE: 'Cotización',
  LANDING_STEP2_DESC:
    'Recibe tu cotización. Nos conectamos con proveedores y te enviamos precios competitivos.',
  LANDING_STEP3_TITLE: 'Aprobar',
  LANDING_STEP3_DESC: 'Entrega segura. Aprueba tu pedido y nosotros gestionamos la logística.',
  LANDING_ABOUT_LABEL: 'Sobre nosotros',
  LANDING_ABOUT_HEADING: 'Hecho para simplificar las compras globales',
  LANDING_ABOUT_P1:
    'En Quote N Buy estamos para ayudarte a encontrar justo lo que necesitas, estés donde estés.',
  LANDING_ABOUT_P2:
    'Sabemos que comprar en el extranjero puede parecer complicado. Por eso lo hacemos simple: cotizaciones rápidas, precios justos y entrega segura a tu hogar o negocio.',
  LANDING_ABOUT_P3:
    'A través de nuestra red global de proveedores de confianza te ayudamos a acceder a repuestos, equipos, electrónica, ropa y artículos difíciles de encontrar en tu zona.',
  LANDING_ABOUT_P4:
    'Nuestro objetivo es que cada compra sea fácil, transparente y fiable, para que compres con confianza y tranquilidad.',
  LANDING_TRUST_LABEL: 'Nuestra confianza',
  LANDING_TRUST_CARD1_TITLE: 'Compra directa de marca',
  LANDING_TRUST_CARD1_DESC:
    'Obtenemos productos directamente de marcas de confianza para garantizar autenticidad y calidad.',
  LANDING_TRUST_CARD2_TITLE: 'Proceso transparente',
  LANDING_TRUST_CARD2_DESC: 'Precios claros, cotizaciones detalladas y actualizaciones constantes, sin sorpresas.',
  LANDING_TRUST_CARD3_TITLE: 'Transacciones seguras',
  LANDING_TRUST_CARD3_DESC: 'Tus pagos e información están protegidos en cada paso.',
  LANDING_TRUST_CARD4_TITLE: 'Entrega fiable',
  LANDING_TRUST_CARD4_DESC: 'Coordinamos un envío seguro y eficiente hasta tu destino.',
  LANDING_REVIEWS_LABEL: 'Opiniones de clientes',
  LANDING_SEE_ALL: 'Ver todas',
  LANDING_VIEW_ALL: 'Ver todas',
  LANDING_READ_MORE: 'Leer más',
  LANDING_READ_LESS: 'Leer menos',
  LANDING_ROLE_CUSTOMER: 'Cliente',
  LANDING_REVIEW_BODY:
    'Necesitaba repuestos de automoción especializados que no había localmente, y Quote N Buy lo gestionó todo. La cotización llegó rápido, el precio fue transparente y me mantuvieron informado durante todo el proceso.',
  LANDING_DAYS_AGO: 'Hace {n} días',
  LANDING_STARS_ARIA: '{n} de 5 estrellas',
  LANDING_FOOTER_COMPANY: 'Empresa',
  LANDING_FOOTER_REVIEWS: 'Reseñas',
  LANDING_FOOTER_FOLLOW: 'Síguenos',
  LANDING_FOOTER_GET_APP: 'Descarga la app',
  LANDING_FOOTER_GOOGLE_PLAY: 'Google Play',
  LANDING_FOOTER_APP_STORE: 'App Store',
  LANDING_MODAL_TITLE: 'Clientes de todo el mundo confían en nosotros',
  LANDING_MODAL_OVERALL_RATING: 'Valoración general',
  LANDING_MODAL_REVIEW_COUNT: '28 opiniones',
  LANDING_FILTER_BY: 'Filtrar por:',
  LANDING_FILTER_ARIA: 'Filtrar opiniones por estrellas',
  LANDING_STARS_ALL: 'Todas las estrellas',
  LANDING_STARS_5: '5 estrellas',
  LANDING_STARS_4: '4 estrellas',
  LANDING_STARS_3: '3 estrellas',
  LANDING_STARS_2: '2 estrellas',
  LANDING_STARS_1: '1 estrella',
  REVIEWS_FILTER_NO_MATCH: 'Ninguna reseña coincide con este filtro',
  COMPLETE_PROFILE_NOTIF_TITLE: 'Completa tu perfil',
  COMPLETE_PROFILE_NOTIF_BODY:
    'Solo un paso más, complete su perfil para comenzar.',
  ARIA_CLOSE: 'Cerrar',
  DASH_HERO_0_TITLE: 'BIENVENIDO A QUOTE N BUY',
  DASH_HERO_0_DESC:
    'Quote N Buy te conecta con proveedores globales de confianza para que obtengas productos de forma rápida, segura y con tranquilidad.',
  DASH_HERO_1_TITLE: 'COMPRA CON CONFIANZA',
  DASH_HERO_1_DESC:
    'Solicita cotizaciones, compara ofertas y aprueba pedidos en un solo lugar, con precios transparentes y entrega fiable.',
  DASH_HERO_2_TITLE: 'ALCANCE GLOBAL, SERVICIO LOCAL',
  DASH_HERO_2_DESC:
    'Te ayudamos a encontrar las piezas y productos adecuados de proveedores verificados en todo el mundo, adaptados a tu plazo y presupuesto.',
  DASH_HERO_3_TITLE: 'TU SOCIO DE COMPRAS',
  DASH_HERO_3_DESC:
    'Desde componentes especializados hasta suministros del día a día, Quote N Buy simplifica el abastecimiento para que te centres en lo importante.',
  DASH_TRENDING_TITLE: 'Productos en tendencia',
  DASH_TRENDING_SUB: 'Favoritos de compradores como tú',
  DASH_MOST_POPULAR: 'Más popular',
  DASH_LEARN_MORE: 'Saber más',
  DASH_SEE_MORE: 'Ver más',
  DASH_HERO_SLIDES_ARIA: 'Diapositivas del banner',
  DASH_SCROLL_TREND_LEFT: 'Desplazar tendencia a la izquierda',
  DASH_SCROLL_TREND_RIGHT: 'Desplazar tendencia a la derecha',
  DASH_NO_PRODUCTS: 'No hay productos',
  VIEW_QUOTE_DETAILS: 'Detalles de la cotización',
  VIEW_QUOTE_SEARCH_ITEMS: 'Buscar Items',
  VIEW_QUOTE_NOTES: 'Notas',
  VIEW_QUOTE_ITEMS_COUNT: 'Items',
  VIEW_QUOTE_DATE_LABEL: 'Fecha',
  VIEW_QUOTE_NOTES_TITLE: 'Notas de la cotización',
  VIEW_QUOTE_NOTES_EMPTY: 'No hay notas para esta cotización.',
  VIEW_QUOTE_NOTES_ITEM_HINT: 'Las notas del administrador se muestran por Item a continuación.',
  VIEW_QUOTE_NOTES_COMMENTS: 'Comentarios',
  VIEW_QUOTE_OTHER_CHARGES_TITLE: 'Desglose de otros cargos',
  VIEW_QUOTE_OTHER_CHARGES_EMPTY: 'No hay cargos detallados registrados.',
  VIEW_QUOTE_OTHER_CHARGES_BTN: 'Ver desglose de otros cargos',
  VIEW_QUOTE_OTHER_CHARGES_NONE: 'Sin detalles de otros cargos',
  VIEW_QUOTE_NO_ITEMS: 'Ningún Item coincide con su búsqueda.',
  VIEW_QUOTE_NO_ITEMS_AT_ALL: 'Aún no hay Items.',
  VIEW_QUOTE_LINE_TOTAL: 'Total de línea',
  VIEW_QUOTE_ETA: 'ETA',
  VIEW_QUOTE_CURRENCY: 'Moneda',
  VIEW_QUOTE_UPDATE_TITLE: 'Actualizar cotización',
  VIEW_QUOTE_UPDATE_BODY_P1: 'Los cambios realizados requieren una nueva cotización por parte del administrador.',
  VIEW_QUOTE_UPDATE_BODY_P2: 'Se enviará una solicitud al administrador. Revisará los detalles y le notificará tan pronto como su cotización esté lista.',
  VIEW_QUOTE_UPDATE_BODY_P3: '¿Desea continuar?',
  VIEW_QUOTE_UPDATED_SUCCESS_TITLE: 'Su cotización ha sido actualizada',
  VIEW_QUOTE_UPDATED_SUCCESS_BODY:
    'Se ha enviado una solicitud al administrador. Estamos revisando los detalles y le notificaremos tan pronto como su cotización esté lista.',
  VIEW_QUOTE_CANCEL_EDIT_TITLE: 'Cancelar edición',
  VIEW_QUOTE_CANCEL_EDIT_BODY_1: 'No se guardarán cambios si cancela.',
  VIEW_QUOTE_CANCEL_EDIT_BODY_2: '¿Desea continuar?',
  VIEW_QUOTE_FOLLOW_EUR: 'El siguiente precio está en EUR',
  VIEW_QUOTE_USE_CANCEL_END_EDIT: 'Use Cancelar abajo para dejar de editar.',

  PENDING_ACTIONS_TITLE: 'Acciones pendientes',
  PENDING_ACTIONS_DETAIL_ARIA: 'Detalle de acciones pendientes',
  PENDING_ACTION_DRAFT_STRIP: 'Tienes un borrador guardado',
  PENDING_ACTION_DRAFT_TITLE: 'Tienes un borrador guardado',
  PENDING_ACTION_DRAFT_DESC: 'Termina y envía tu solicitud para obtener una cotización.',
  PENDING_ACTION_DRAFT_CTA: 'Continuar borrador',
  PENDING_ACTION_WIRE_STRIP: 'Completa tu pago para continuar',
  PENDING_ACTION_WIRE_TITLE: 'Completa tu pago para continuar',
  PENDING_ACTION_WIRE_DESC_WITH_ID: 'Tu pedido {id} está pendiente de transferencia bancaria.',
  PENDING_ACTION_WIRE_DESC: 'Tienes un pedido pendiente de transferencia bancaria.',
  PENDING_ACTION_WIRE_CTA: 'Ver detalles de pago',
  PENDING_ACTION_CC_STRIP: 'El pago no se completó',
  PENDING_ACTION_CC_TITLE: 'El pago no se completó',
  PENDING_ACTION_CC_DESC_WITH_ID:
    'Pedido {id}: por favor intenta el pago nuevamente para continuar.',
  PENDING_ACTION_CC_DESC:
    'No te preocupes, ¡pasa a veces! Revisa tus datos o inténtalo de nuevo para continuar.',
  PENDING_ACTION_CC_CTA: 'Actualizar detalles de pago',
  PENDING_ACTION_PROFILE_STRIP: 'Completa tu perfil',
  PENDING_ACTION_PROFILE_TITLE: 'Completa tu perfil',
  PENDING_ACTION_PROFILE_DESC: 'Solo falta un paso, completa tu perfil para empezar a cotizar.',
  PENDING_ACTION_PROFILE_CTA: 'Completar perfil',
}

const Translate = getFromStorage({ key: StorageConstant?.Translate });

export const LanguageConstants =
  Translate === 'spa' ? { ...EnglishLanguage, ...SpanishLanguage } : EnglishLanguage;